import { StandaloneProse, StandaloneProseProps } from 'base/components/Prose';
import deepmerge from 'deepmerge';
import { useAppState } from 'lib/hooks/useAppState';
import { cn } from 'lib/utils';

export const HantStandaloneProse: typeof StandaloneProse = ({ options, ...props }) => {
  const [{ affiliate }] = useAppState();

  const withSecondaryColor = affiliate === 'nyheter';

  const secondaryColorClassName = cn(
    'prose-a:text-hn-secondary-700',
    'prose-a:visited:text-hn-secondary-700',
    'prose-a:hover:text-hn-secondary-900'
  );

  const className = cn(options?.className, withSecondaryColor ? secondaryColorClassName : undefined);

  return (
    <StandaloneProse
      options={deepmerge<StandaloneProseProps['options']>(options, {
        className,
      })}
      {...props}
    />
  );
};

export default HantStandaloneProse;
